import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-geocerca-dashboard-element',
  templateUrl: './geocerca-dashboard-element.component.html',
  styleUrls: ['./geocerca-dashboard-element.component.scss']
})
export class GeocercaDashboardElementComponent implements OnInit, OnDestroy {
  token: string | null = null;
  apiBaseUrl = environment.api.url;
  movementsApiBaseUrl = `${environment.api.url.replace(/\/+$/, '')}/api/GeoFence`;
  view = 'dashboard';

  private routeDataSubscription: Subscription | null = null;

  constructor(private _route: ActivatedRoute) {}

  // Vistas del widget <geo-dashboard> cuya URL interna por defecto coincide con el
  // path de una ruta legada de Angular 9 (ver GeoDashboardRedirectGuardService) — el
  // valor es a dónde regresar en esta misma app Angular 9 si eso pasa.
  private static readonly BOOTSTRAP_GUARD_TARGET_BY_VIEW: Record<string, string> = {
    'administrador-2': '/admin/administrador-2',
    minutas: '/admin/minutas-2',
    users: '/admin/users-2',
    employers: '/admin/employers-2',
    projects: '/admin/projects-2',
    vehicles: '/admin/vehicles-2',
    profile: '/admin/profile-2',
    inicio: '/admin/inicio-2',
    'social-security': '/admin/social-security-2',
  };

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token');

    // Rutas como /admin/geocerca-vnext-test y /admin/users-2 comparten este mismo
    // componente Angular 9, así que el router reutiliza la instancia en vez de
    // recrearla al navegar entre ellas (ngOnInit no se vuelve a ejecutar). Por eso
    // `view` se actualiza desde el Observable `_route.data` (que sí emite de nuevo
    // en cada navegación, incluso reutilizando la instancia) y no solo desde
    // `_route.snapshot.data` — leer solo el snapshot dejaba `view` (y por lo tanto
    // el atributo `view` de <geo-dashboard>) congelado en la primera vista cargada.
    this.routeDataSubscription = this._route.data.subscribe((data) => {
      this.view = data.geoDashboardView || 'dashboard';

      const backTo = GeocercaDashboardElementComponent.BOOTSTRAP_GUARD_TARGET_BY_VIEW[this.view];
      if (backTo) {
        // El widget <geo-dashboard> bootstrapea su propio Router interno una sola vez
        // por carga de página; en ese primer bootstrap puede hacer un navigateByUrl
        // espurio hacia la ruta legada de Angular 9 con el mismo path (p.ej.
        // /admin/companies/companies-list o /admin/minutas/minuta-personal). Esta
        // bandera le permite al GeoDashboardRedirectGuardService detectar esa
        // navegación y devolver al usuario a esta misma vista nueva.
        sessionStorage.setItem('geoDashboardBootstrapGuard', `${Date.now()}|${backTo}`);
      }
    });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
  }
}
